import { AlloyIcon } from 'cat-ecommerce-alloy';
import { useTranslation } from 'react-i18next';

const RemanufacturedPartMessage = () => {
  const [t] = useTranslation();

  return (
    <div className={`d-flex align-items-baseline mt-2`}>
      <span className={`u-fill--DarkGray my-0 me-2 mb-0`}>
        <AlloyIcon height={14.67} width={14.67} icon={'icon-remanufactured'} />
      </span>
      <p className={`u-color--ExtraDarkGray u-fs--12 mb-0`}>
        {t('REMANUFACTURED_PART')}
      </p>
    </div>
  );
};

export default RemanufacturedPartMessage;
